<template>
    <div class="modal fade" :id="'vmbc'+ id" role="dialog">
        <div class="modal-dialog modal-lg">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{service.name}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <table class="table table-striped table-bordered">
                    <tr>
                        <td>
                            <input type="text" class="form-control mt-1" v-model="options.Name" placeholder="Name">
                        </td>
                        <td>
                            <input type="number" class="form-control mt-1" v-model="options.Price" placeholder="Price">
                        </td>
                        <td><button class="btn btn-success" @click="saveOption"><i class="fa fa-plus"></i></button></td>
                    </tr>
                </table>

                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="trial in trials" :key="trial.Name">
                            <td><input type="text" class="form-control" v-model="trial.Name"></td>
                            <td><input type="number" class="form-control" v-model="trial.Price"></td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="updateTrial"><i class="fa fa-save"></i></button>
                <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
            </div>
        </div>

        </div>
    </div>
</template>
<script>
export default {

    props:['service', 'id', 'trials'],
    data() {
        return {
            options: {
                TrialID: 1,
                ClassID: this.id,
                Name: '',
                Price: ''
            },
        }
    },
    methods: {
        saveOption() {
            const option = {
                TrialID: this.options.TrialID,
                ClassID: this.id,
                Name: this.options.Name,
                Price: this.options.Price
            };

            axios
            .post('./api/Trial/Save', {
                options: option
            })
            .then(response => {
                this.trials.push({
                    id: response.data.id,
                    TrialID: option.TrialID,
                    ClassID: option.ClassID,
                    Name: option.Name,
                    Price: option.Price
                });
                this.options.Name = '';
                this.options.Price = '';
            });
        },
        updateTrial() {
            axios
            .post('./api/Trial/Update', {
                options: this.trials
            })
            .then(response => {
                $('.modal').modal('hide')
                // console.log(response);
            });
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Trials/TrialOptions.vue